
import { Component, Vue } from 'vue-property-decorator';
import FormHeader from '@/components/headers/form-header/form-header.vue';

import InputCCNumber from '@/components/inputs/text/cc_number.input.vue';
import InputCCType from '@/components/inputs/text/cc_type.input.vue';
import InputName from '@/components/inputs/text/name.input.vue';
import InputAge from '@/components/inputs/text/age.input.vue';
import InputEps from '@/components/inputs/text/eps.input.vue';
import InputEmail from '@/components/inputs/text/email.input.vue';
import InputPhone from '@/components/inputs/text/phone.input.vue';
import InputAddress from '@/components/inputs/text/address.input.vue';
import InputCity from '@/components/inputs/text/city.input.vue';

import InputBookingDate from '@/components/inputs/booking/booking-date.input.vue';
import InputBookingHour from '@/components/inputs/booking/booking-hour.input.vue';
import InputBookingSport from '@/components/inputs/booking/booking-sport.input.vue';

import UIHealthTemperatureInputComponent from "@/components/inputs/health-temperature.input.vue";
import UIHealthSymptonsInputComponent from "@/components/inputs/health-symtoms.input.vue";

import InputPark from '@/components/inputs/options/park.input.vue';
import InputClientType from '@/components/inputs/options/client-type.input.vue';

import { IUser } from '@/models/IUser.model';
import { IPark } from '@/models/IPark.model';
import { BookingAPI } from '@/apis/bookings.api';

import moment from 'moment';
import { IBooking } from '@/models/IBooking.model';

@Component({
  components: {
    'form-header': FormHeader,
    'input-cc-number': InputCCNumber,
    'input-cc-type': InputCCType,
    'input-name': InputName,
    'input-age': InputAge,
    'input-eps': InputEps,
    'input-email': InputEmail,
    'input-phone': InputPhone,
    'input-address': InputAddress,
    'input-city': InputCity,
    'input-booking-date':InputBookingDate,
    'input-booking-hour':InputBookingHour,
    'input-booking-sport':InputBookingSport,
    "ui-health-temperature-input": UIHealthTemperatureInputComponent,
    "ui-health-symptoms-input": UIHealthSymptonsInputComponent,
  },
})
export default class CheckView extends Vue {

  private cc_number = '';
  private parkId = '';
  private clientType = '';

  private cc_type: string = '';
  private name: string = '';
  private phone: string = '';
  private age: string = '';
  private eps: string = '';
  private email: string = '';
  private address: string = '';
  private city: string = '';
  private parent: any = {};

  private date = new Date(); 
  private hour = ''; 
  private bookings:IBooking[] = []; 

  private bookingSport = '';
  private bookingDate: Date = new Date();
  private bookingDDMMYYYY: string =  '';
  private bookingHour: string = '';

  private userTemperature: number = 25;
  private userCovid: any = {};

  private isBookingLoaded = false;
  private isToogleUser = false;

  goToAcces(){
    this.$router.push({ 
      name: 'AccessView'
    });
  }

  private async mounted() {

    const bookingId = this.$route.params.bookingId;
    const isFetchBookingReady = await this.$store.dispatch('fetchBookingById', bookingId)
    const isFetchParkReady = await this.$store.dispatch('setParkById',  this.booking.parkName.replace(/[^A-Z0-9]+/ig, "_") )
  
    this.bookingDate = this.booking.date;
    this.bookingHour = this.booking.hour || '';
    this.bookingSport = this.booking.sport || '';
    this.bookingDDMMYYYY = this.booking.ddmmyyyy;

    this.cc_number = this.booking.cc_number || (this.user as any).cc;
    this.cc_type = this.booking.cc_type || (this.user as any).type;
    this.name = this.booking.name;
    this.phone = this.booking.phone;
    this.age = this.booking.age;
    this.eps = this.booking.eps;
    this.email =this.booking.email;
    this.address = this.booking.address;
    this.city = this.booking.city;
    this.parent = {};
    this.userCovid = {
      contact: "yes",
      symptoms: "yes"
    };
    this.userTemperature = 25;

    this.isBookingLoaded = true;
  }

  setToogleUser(){
    this.isToogleUser = !this.isToogleUser;
  }
  setCity($text) {
    this.city = $text;
  }
  setAddress($text) {
    this.address = $text;
  }
  setEmail($text) {
    this.email = $text;
  }
  setPhone($text) {
    this.phone = $text;
  }
  setEps($text) {
    this.eps = $text;
  }
  setAge($text) {
    this.age = $text;
  }
  setName($text) {
    this.name = $text;
  }
  setCCNumber($text) {
    this.cc_number = $text;
  }
  setCCType($text) {
    this.cc_type = $text
  }
  onBookingSportChange($text){
    this.bookingSport = $text
  }
  onBookingDateChange($text){
    this.bookingDate = $text
    this.date = $text;
  }
  onBookingHourChange($text){
    this.bookingHour = $text;
  }
  public onHealthSymptomsChange($covid: any): void {
    this.userCovid = $covid;
  }
  public onHealthTemperatureChange($temperature: number): void {
    if($temperature > 37.9){
      this.$swal(' TEMPERATURA ELEVADA','El usuario no puede ingresar','error')
      this.userTemperature = $temperature;
    } else {
      this.userTemperature = $temperature;
    }
  }
  public get user(): IUser {
    return this.$store.state.user;
  }

  public get park(): IPark {
    return this.$store.state.park;
  }

  public get booking(): IBooking {
    return this.$store.state.booking;
  }

  async doCheck(){

    if(
      this.booking && 
      this.userTemperature && 
      this.userCovid
    ){
      const bookApi = new BookingAPI();
      const bookID = this.booking.id;
      const bookPayload = {
        id: bookID,
        date: this.date,
        hour: this.bookingHour,
        ddmmyyyy: this.bookingDDMMYYYY,
        parkName: this.park.name,
        cc_number: this.booking.cc_number || (this.user as any).cc,
        cc_type: this.booking.cc_type || (this.user as any).type, 
        name: this.booking.name,
        email: this.booking.email,
        city: this.booking.city,
        phone: this.booking.phone,
        address: this.booking.address,
        age: this.booking.age,
        eps: this.booking.eps,
        sport: this.bookingSport,
        temperature: this.userTemperature,
        contact: this.userCovid.contact,
        symptoms: this.userCovid.symptoms
      };
      await bookApi.patch(bookPayload)     
    }

    if(
      this.booking && 
      this.userTemperature && 
      this.userCovid && 
      this.userCovid.contact === "no" &&
      this.userCovid.symptoms === "no"
    ){  
      this.$swal('Acceso Garantizado', '','success')
      this.$router.push({ name: 'AccessView' });
    } else {
      this.$swal('Usuario No Puede Ingresar al Parque', '','error')
    }

  }



}